import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ChevronsIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 70 40"
    >
      <path
        d="M10 10 L18 20 L10 30"
        fill="none"
        stroke={color}
        strokeWidth={4}
      />
      <path
        d="M30 10 L38 20 L30 30"
        fill="none"
        stroke={color}
        strokeWidth={4}
      />
      <path
        d="M50 10 L58 20 L50 30"
        fill="none"
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  );
};
